// canonical.service.ts
import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class CanonicalService {
  constructor(@Inject(DOCUMENT) private dom: Document) {}

  setCanonical(url: string): void {
    let link: HTMLLinkElement = this.dom.querySelector('link[rel="canonical"]');
    if (link) {
      link.setAttribute('href', url);
    } else {
      link = this.dom.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', url);
      this.dom.head.appendChild(link);
    }
  }

  setPrev(url: string): void {
    let link: HTMLLinkElement = this.dom.querySelector('link[rel="prev"]');
    if (link) {
      link.setAttribute('href', url);
    } else {
      link = this.dom.createElement('link');
      link.setAttribute('rel', 'prev');
      link.setAttribute('href', url);
      this.dom.head.appendChild(link);
    }
  }

  setNext(url: string): void {
    let link: HTMLLinkElement = this.dom.querySelector('link[rel="next"]');
    if (link) {
      link.setAttribute('href', url);
    } else {
      link = this.dom.createElement('link');
      link.setAttribute('rel', 'next');
      link.setAttribute('href', url);
      this.dom.head.appendChild(link);
    }
  }

  // Add this method to your canonical service

setEventSchema(eventData: any): void {
  let script: HTMLScriptElement = this.dom.querySelector('script[id="event-schema"]');
  if (script) {
    script.innerHTML = JSON.stringify(eventData, null, 2);
  } else {
    script = this.dom.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.setAttribute('id', 'event-schema');
    script.innerHTML = JSON.stringify(eventData, null, 2);
    this.dom.head.appendChild(script);
  }
}
}
